import React from 'react';
import { FaShoppingCart, FaMoneyBillWave, FaCreditCard, FaUndo } from 'react-icons/fa';
import { useTranslation } from '../../../context/LanguageContext';

const OrderSummary = ({ summary, formatCurrency }) => {
    const { t } = useTranslation();
    const cards = [
        {
            title: t('admin.total_orders'),
            value: summary.total_orders,
            icon: FaShoppingCart,
            color: 'yellow'
        },
        {
            title: t('admin.cash_orders'),
            value: formatCurrency(summary.cash_total),
            icon: FaMoneyBillWave,
            color: 'green'
        },
        {
            title: t('admin.card_orders'),
            value: formatCurrency(summary.card_total),
            icon: FaCreditCard,
            color: 'blue'
        },
        {
            title: t('admin.returned_orders'),
            value: summary.returned_orders,
            icon: FaUndo,
            color: 'red'
        }
    ];

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
            {cards.map((card, index) => (
                <div
                    key={index}
                    className="bg-white rounded-xl shadow-lg p-4 sm:p-6 transition-all duration-300 hover:shadow-xl"
                >
                    <div className="flex items-center justify-between">
                        <div className="flex-1">
                            <p className="text-xs sm:text-sm font-medium text-gray-600 truncate">
                                {card.title}
                            </p>
                            <p className="mt-1 sm:mt-2 text-xl sm:text-2xl xl:text-3xl font-semibold text-gray-900">
                                {card.value}
                            </p>
                        </div>
                        <div className={`p-2 sm:p-3 rounded-full bg-${card.color}-100 flex-shrink-0 ml-2`}>
                            <card.icon className={`w-4 h-4 sm:w-5 sm:h-5 xl:w-6 xl:h-6 text-${card.color}-600`} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default OrderSummary;
